import React, { Component } from 'react';

export default class InventoryAddTemperature extends Component {

  render() {
    if (this.props.canAddTemperature) {
      return (
        <div className="add-temperature">
          <div className="col-md-4 p-0">
            <input type="number" id="temperature" placeholder="Add new temperature in ºF" className="form-control" value={this.props.temperature} onChange={(temp) => {this.props.onTemperatureChange(temp)} }/>
          </div>
          <a className="btn btn-primary mr-05 color-white" onClick={ this.props.onTemperatureAdd }><i className="fa fa-plus mr-05"></i>Temperature</a>
        </div>
      );
    } else {
      return null
    }
  } 

}